module.exports = __webpack_public_path__ + "img/download_invoice.a18ed95e.png";